import angular from "angular";
import "ng-file-upload";
import uiPagination from "angular-ui-bootstrap/src/pagination";
import uiModal from "angular-ui-bootstrap/src/modal";
import uiTooltip from "angular-ui-bootstrap/src/tooltip";
import { crud } from "../common/crud/crud.js";
import { stavkaNaloga } from "../stavkaNaloga/stavkaNaloga.js";
import { RadniNalogListComponent } from "./radniNalogList.component.js";
import { RadniNalogDetailsComponent } from "./radniNalogDetails.component.js";
import { PlanRadaComponent } from "./planRada.component.js";
import { ShemaComponent } from "./shema.component.js";
import { RadniNalogCreateComponent } from "./radniNalogCreate.component.js";
import { RadniNalogEditComponent } from "./radniNalogEdit.component.js";
import { RadniNalogWizardFormComponent } from "./radniNalogWizardForm.component.js";
import { EvidencijaNalogaComponent } from "./evidencijaNaloga.component.js";
import { KomentariComponent } from "./komentari.component.js";
import { RnLinkComponent } from "./rnLink.component.js";
import RadniNalogService from "./radniNalog.service.js";

const radniNalog = angular.module("radniNalog", [
    uiPagination,
    uiModal,
    uiTooltip,
    "ngFileUpload",
    crud.name,
    stavkaNaloga.name
]);

radniNalog.component("radniNalogList", RadniNalogListComponent);
radniNalog.component("radniNalogDetails", RadniNalogDetailsComponent);
radniNalog.component("planRada", PlanRadaComponent);
radniNalog.component("shema", ShemaComponent);
radniNalog.component("radniNalogCreate", RadniNalogCreateComponent);
radniNalog.component("radniNalogEdit", RadniNalogEditComponent);
radniNalog.component("radniNalogWizardForm", RadniNalogWizardFormComponent);
radniNalog.component("evidencijaNaloga", EvidencijaNalogaComponent);
radniNalog.component("komentari", KomentariComponent);
radniNalog.component("rnLink", RnLinkComponent);

radniNalog.service("RadniNalogService", RadniNalogService);

export { radniNalog };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalog.js